import { Link } from "react-router-dom";
import { useSocialLinks } from "../../hooks/components/Social/useSocialLinks";

import {FooterStyleOne} from "./Footer-style-one"
import {FooterStyleTwo} from "./Footer-style-two"
import {FooterStyleThree} from "./Footer-style-three"

const ContentStackMenu = ({ contentStack }) => {
  return (
    <>
      {contentStack?.map((contentStac, i) => {
        return (
          <ul key={i}>
            {contentStac?.props?.el?.innerElements?.length > 0 && (
              <>
                <div className="linksTitle px-0">
                  {contentStac.props.el.contentElementName}
                </div>
                <>
                  <ul>
                    {contentStac.props.el.innerElements.map((d, i) => {
                      return (
                        <li key={i}>
                          <Link
                            className={`nav-link px-0 py-0`}
                            to={d.linkUrl}
                            key={i}
                          >
                            {d.contentElementName}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </>
              </>
            )}
          </ul>
        );
      })}
    </>
  );
};

const PoweredBy = ({ theme, styleList }) => {
  return (
    <>
      {theme && theme.footerPoweredBy && theme.footerPoweredBy !== "undefined" && (
        <div className="d-flex align-items-center mx-2">
          Powered By:&nbsp;
          <img
            src={`${theme.footerPoweredBy?.url}`}
            alt=""
            className="img-fluid"
            style={styleList}
          />
        </div>
      )}
    </>
  );
};




const FooterContent = ({
  siteSetting,
  contentStack1,
  ribbonMenu,
  logo,
  theme,
  contentStack,
  formElement,
}) => {
  const { Social } = useSocialLinks(siteSetting);

  switch (theme.footerStyleOption) {
    case "two":
      return (
        <FooterStyleTwo
          logo={logo}
          theme={theme}
          ribbonMenu={ribbonMenu}
          contentStack={contentStack}
          Social={Social}
        />
      );
    case "three":
      return (
        <FooterStyleThree
          logo={logo}
          theme={theme}
          ribbonMenu={ribbonMenu}
          formElement={formElement}
        />
      );
    default:
      return (
        <FooterStyleOne
          logo={logo}
          theme={theme}
          ribbonMenu={ribbonMenu}
          contentStack={contentStack1}
          formElement={formElement}
          Social={Social}
        />
      );
  }
};

export { FooterContent , PoweredBy, ContentStackMenu};
